export function parseHelpCenterArticle(article?: string): string {
  if (!article) {
    return article;
  }

  return article.replace(/(<iframe .*?youtube.*?)(\?.*?)("><\/iframe>)/g, '$1$2&iv_load_policy=3&modestbranding=1$3');
}
